'use strict';

import React from 'react'

import LegalBlogIcon from '@/Icons/LegalBlogIcon'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Logo   from '@Pure/Logo'

import _ from 'lodash'

const moment = window.moment;

let app = window.app;

export default class MyECPage extends React.Component
{
	constructor (props)
	{
		super();

		this.state =
		{
			loading: false,
			articles: [],
			permissions: { title: 'not_auth' }
		};

		this.handleSessionChange = this.handleSessionChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange (source)
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC instanceof Object === false) return;

		let filter_query =
		{
			type: 'EC',
			EC: app.state.session.EC.id,
			limit: 5,
			sort: 'date DESC',
		};

		component.setState(
		{
			permissions: _.cloneDeep(app.state.session.permissions || { })
		});

		component.setState({ loading: true });

		qwest.post('/CMS/getAll',
		{
			model: 'blog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				articles: response.data,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let output, layout, loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['yellow', 'bg-white'] } />;
		}

		let articles = state.articles.map(function (article, key)
		{
			let img_url = article.images ? article.images[0] : null;

			if (img_url)
			{
				img_url = img_url.url;
			}

			if (!img_url)
			{
				img_url = article.images instanceof Array ? article.images[0] : null;

				img_url = img_url ? img_url.url : null;
			}

			if (!img_url) img_url = '/images/logo_synergies.svg';

			let short_description = (article.content || '').split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 100, '') } } />
			);

			let output =
			(
				<div className="c-model-preview-item article o-grid__item u-flex"
					key={ article.id + key }>

					<div className="c-model-preview c-model-preview--article">

						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/mon-espace/blog/' + article.id }>
								<Image className="c-model-preview__img"
									src={ img_url } />
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/mon-espace/blog/' + article.id }
								className="c-model-preview__title-link">
								{ article.title }
							</Link>
						</h2>

						<div className="c-model-preview__themes">
							<div className="c-model-preview__theme">
								{
									article.date
									? moment(article.date)
										.format('dddd DD MMMM YYYY')
									: undefined
								}
							</div>
						</div>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/mon-espace/blog/' + article.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir l'article
								</Link>
							</div>

						</div>

						<Link href={ '/accueil/mon-espace/blog/' + article.id }
								className="u-link-only"></Link>

					</div>

				</div>
			);

			return output;
		});

		const legal_blog = state.permissions?.title === 'EC' ?
		(
			<div className="o-grid__item u-flex">

				<div className="c-color-block
					c-color-block--img c-color-block--places">
					{ loader }

					<LegalBlogIcon
						className="c-color-block__svg-icon"
					/>

					<div className="c-color-block__content">
						<div className="c-color-block__title">
							Infos juridiques
						</div>
					</div>

					<Link className="c-color-block__link"
						href="/blog-juridique"
					/>

				</div>

			</div>
		)
		: undefined;

		const col_size = legal_blog ? '4' : '3';

		output =
		(
			<Layout history={ props.history } page_title="Mon espace">

				<div className="page-content">

					<HolidaysMessage />

					<div className={ 'o-grid-' + col_size + ' u-flex' }>

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--img c-color-block--places">
								{ loader }

								<svg className="o-svg-icon o-svg-icon--blog c-color-block__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-blog"></use>
								</svg>

								<div className="c-color-block__content">
									<div className="c-color-block__title">
										Infos &amp; Actu
									</div>
								</div>

								<Link className="c-color-block__link"
									href="/accueil/mon-espace/blog"></Link>

							</div>

						</div>

						{ legal_blog }

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--img c-color-block--artists">
								{ loader }

								<svg className="o-svg-icon o-svg-icon--blog_CE c-color-block__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-blog_CE"></use>
								</svg>

								<div className="c-color-block__content">
									<div className="c-color-block__title">
										Infos pratiques
									</div>
								</div>

								<Link className="c-color-block__link"
									href="/accueil/mon-espace/infos-pratiques"></Link>

							</div>

						</div>

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--img c-color-block--meeting-record">
								{ loader }

								<svg className="o-svg-icon o-svg-icon--meeting_record c-color-block__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-meeting_record"></use>
								</svg>

								<div className="c-color-block__content">
									<div className="c-color-block__title">
										Comptes rendus de réunion
									</div>
								</div>

								<Link className="c-color-block__link"
									href="/accueil/mon-espace/comptes-rendus-de-reunion"></Link>

							</div>

						</div>

					</div>

					<div className="o-content">

						<div className="c-title c-title--v2">
							<h2 className="c-title__txt">Derniers articles</h2>
						</div>

					</div>

					<div className="o-grid-5 my-EC-articles">
						{ articles }
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}